export default __webpack_public_path__ + "static/media/img_delivery_b.ea95499a.webp";